// Month-key helpers for the "YYYY-MM" schema.
// All calc / display / period-selector logic anchors on these.

const pad = (n) => String(n).padStart(2, "0");

// "2026-07" for today (browser-local time)
export const currentMonthKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
};

// Add `delta` months to a "YYYY-MM" key. Handles year rollover.
export const addMonths = (key, delta) => {
  const [y, m] = String(key).split("-").map(Number);
  if (!y || !m) return key;
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}`;
};

// Inclusive month-key range: [start, ..., start+n-1]
export const monthRange = (start, count) =>
  Array.from({ length: Math.max(0, count) }, (_, i) => addMonths(start, i));

// Compare two "YYYY-MM" keys: -1 if a<b, 0 if a==b, 1 if a>b
export const cmpMonth = (a, b) => (a < b ? -1 : a > b ? 1 : 0);

// Diff in months between two "YYYY-MM" keys (b - a). Positive if b is later.
export const diffMonths = (a, b) => {
  const [ay, am] = String(a).split("-").map(Number);
  const [by, bm] = String(b).split("-").map(Number);
  return (by - ay) * 12 + (bm - am);
};

// Default rolling window: current month + next 11 = 12 months.
export const defaultRollingWindow = () => monthRange(currentMonthKey(), 12);

// Union sort of stored months + a target window (for period selector to
// show empty future months alongside stored past ones).
export const unionMonths = (a = [], b = []) => {
  const s = new Set([...(a || []), ...(b || [])]);
  return Array.from(s).sort();
};
